import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X, ArrowUpRight } from "lucide-react";
import { navLinks, profile } from "../../mock/mock";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <motion.header
      initial={{ y: -20, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.6, ease: [0.2, 0.7, 0.2, 1] }}
      className={`fixed top-0 left-0 right-0 z-50 transition-[background,backdrop-filter,border] duration-500 ${
        scrolled
          ? "border-b border-white/5 bg-[rgba(10,11,10,0.7)] backdrop-blur-xl"
          : "border-b border-transparent bg-transparent"
      }`}
    >
      <div className="mx-auto max-w-[1400px] px-6 md:px-10 py-4 flex items-center justify-between">
        <a href="#top" className="flex items-center gap-3 group">
          <span className="relative inline-flex h-9 w-9 items-center justify-center rounded-full border border-white/15 bg-white/5">
            <span className="font-display text-[18px] leading-none">A</span>
            <span className="absolute inset-0 rounded-full ring-1 ring-[var(--sage)]/0 group-hover:ring-[var(--sage)]/60 transition" />
          </span>
          <div className="flex flex-col leading-tight">
            <span className="font-display text-[17px]">Anand Baral</span>
            <span className="mono text-[10px] tracking-[0.18em] text-[var(--muted)] uppercase">
              Digital · Creative · Strategy
            </span>
          </div>
        </a>

        <nav className="hidden md:flex items-center gap-8">
          {navLinks.map((l) => (
            <a key={l.href} href={l.href}
              className="mono text-[12px] tracking-[0.18em] uppercase text-[var(--text-dim)] hover:text-[var(--text)] underline-sage pb-1">
              {l.label}
            </a>
          ))}
        </nav>

        <div className="hidden md:flex items-center gap-3">
          <a href={`tel:${profile.phoneLink}`} className="btn-ghost text-sm">
            Let's Talk <ArrowUpRight size={16} />
          </a>
        </div>

        <button onClick={() => setOpen((v) => !v)}
          className="md:hidden inline-flex h-10 w-10 items-center justify-center rounded-full border border-white/10"
          aria-label="Toggle menu">
          {open ? <X size={18} /> : <Menu size={18} />}
        </button>
      </div>

      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.35, ease: [0.2, 0.7, 0.2, 1] }}
            className="md:hidden overflow-hidden border-t border-white/5 bg-[rgba(10,11,10,0.95)] backdrop-blur-xl">
            <div className="px-6 py-6 flex flex-col gap-5">
              {navLinks.map((l) => (
                <a key={l.href} href={l.href} onClick={() => setOpen(false)}
                  className="font-display text-2xl text-[var(--text)] flex items-center justify-between border-b border-white/5 pb-4">
                  {l.label}
                  <ArrowUpRight size={18} className="text-[var(--sage)]" />
                </a>
              ))}
              <a href={`tel:${profile.phoneLink}`} className="btn-primary justify-center mt-2">Let's Talk</a>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </motion.header>
  );
}
